// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see OfflineTransactionReportEvent
 */
export var OfflineTransactionReport = function (_a) {
    var type = _a.type, count = _a.count, externalIds = _a.externalIds, oldestTransactionTimestamp = _a.oldestTransactionTimestamp, mostRecentTransactionTimestamp = _a.mostRecentTransactionTimestamp, retryIntervals = _a.retryIntervals;
    return ({
        name: "Offline Transaction Report",
        parameters: {
            cdf_entity: "Offline",
            cdf_action: "Transaction",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            count: count !== undefined && count !== null ? count.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_ids: externalIds !== undefined && externalIds !== null ? externalIds.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            oldest_transaction_timestamp: oldestTransactionTimestamp !== undefined && oldestTransactionTimestamp !== null ? oldestTransactionTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            most_recent_transaction_timestamp: mostRecentTransactionTimestamp !== undefined && mostRecentTransactionTimestamp !== null ? mostRecentTransactionTimestamp.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            retry_intervals: retryIntervals !== undefined && retryIntervals !== null ? retryIntervals.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OfflineTransactionRetryEvent
 */
export var OfflineTransactionRetry = function (_a) {
    var type = _a.type, externalId = _a.externalId, retryCount = _a.retryCount;
    return ({
        name: "Offline Transaction Retry",
        parameters: {
            cdf_entity: "Offline",
            cdf_action: "Transaction",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            retry_count: retryCount !== undefined && retryCount !== null ? retryCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OfflineTransactionAddedEvent
 */
export var OfflineTransactionAdded = function (_a) {
    var type = _a.type, externalId = _a.externalId, nextRetryAt = _a.nextRetryAt, reason = _a.reason, httpStatusCode = _a.httpStatusCode, errorDescription = _a.errorDescription, commonNetworkError = _a.commonNetworkError;
    return ({
        name: "Offline Transaction Added",
        parameters: {
            cdf_entity: "Offline",
            cdf_action: "Transaction",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            next_retry_at: nextRetryAt !== undefined && nextRetryAt !== null ? nextRetryAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            http_status_code: httpStatusCode !== undefined && httpStatusCode !== null ? httpStatusCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_description: errorDescription !== undefined && errorDescription !== null ? errorDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            common_network_error: commonNetworkError !== undefined && commonNetworkError !== null ? commonNetworkError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OfflineTransactionRemovedEvent
 */
export var OfflineTransactionRemoved = function (_a) {
    var type = _a.type, externalId = _a.externalId, retryCount = _a.retryCount, reason = _a.reason, errorReason = _a.errorReason;
    return ({
        name: "Offline Transaction Removed",
        parameters: {
            cdf_entity: "Offline",
            cdf_action: "Transaction",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            retry_count: retryCount !== undefined && retryCount !== null ? retryCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_reason: errorReason !== undefined && errorReason !== null ? errorReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OfflineTransactionRescheduledEvent
 */
export var OfflineTransactionRescheduled = function (_a) {
    var type = _a.type, externalId = _a.externalId, previousRetryAt = _a.previousRetryAt, nextRetryAt = _a.nextRetryAt, retryCount = _a.retryCount, reason = _a.reason, httpStatusCode = _a.httpStatusCode, errorDescription = _a.errorDescription, commonNetworkError = _a.commonNetworkError;
    return ({
        name: "Offline Transaction Rescheduled",
        parameters: {
            cdf_entity: "Offline",
            cdf_action: "Transaction",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            previous_retry_at: previousRetryAt !== undefined && previousRetryAt !== null ? previousRetryAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            next_retry_at: nextRetryAt !== undefined && nextRetryAt !== null ? nextRetryAt.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            retry_count: retryCount !== undefined && retryCount !== null ? retryCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            reason: reason !== undefined && reason !== null ? reason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            http_status_code: httpStatusCode !== undefined && httpStatusCode !== null ? httpStatusCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            error_description: errorDescription !== undefined && errorDescription !== null ? errorDescription.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            common_network_error: commonNetworkError !== undefined && commonNetworkError !== null ? commonNetworkError.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OfflineTransactionCancelEvent
 */
export var OfflineTransactionCancel = function (_a) {
    var type = _a.type, externalId = _a.externalId, retryCount = _a.retryCount;
    return ({
        name: "Offline Transaction Cancel",
        parameters: {
            cdf_entity: "Offline",
            cdf_action: "Transaction",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            external_id: externalId !== undefined && externalId !== null ? externalId.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            retry_count: retryCount !== undefined && retryCount !== null ? retryCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
